module.exports = __webpack_public_path__ + "img/address.dc303a3b.png";